import {EmbeddedPendingComponent} from "~/components/routerHelpers/embeddedPendingComponent";
import {Route} from "./route";

export function PendingComponent() {
    return <EmbeddedPendingComponent route={Route as never} />;
}
